<template>
  <v-dialog
    :value="value" @input="input => $emit('input', input)"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card dark class="flex-column d-flex">
      <div>
        <v-toolbar dark >
          <v-btn
            icon
            dark
            @click="$emit('input', null)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{video.created_at | datetime}}</v-toolbar-title>
        </v-toolbar>
      </div>
      <div class="d-flex justify-center align-center flex-column flex-grow-1 pt-10">
        <iframe width="800" height="450" :src="`https://www.youtube.com/embed/${video.video_id}`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <p class="mt-5 mb-5" style="max-width: 800px; white-space: pre-line;">
          {{video.description}}
        </p>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'video']
}
</script>

<style lang="scss" scoped>

</style>